// extracted by mini-css-extract-plugin
export default {"container":"QuotaMeterBanner-module__container--QJsKZ"};